"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var auth0_js_1 = require("auth0-js");
var Cookie = require("js-cookie");
var _ = require("lodash");
var __1 = require("../");
var logger_const_1 = require("./../const/logger.const");
var Auth0 = (function () {
    function Auth0(config) {
        this.authResult = {};
        this.authData = {
            accessToken: '',
            idToken: '',
            expiresAt: '',
            idp_uuid: '',
        };
        this.authenticated = false;
        this.expiresAt = '';
        this.accessToken = '';
        this.idToken = '';
        this.customLoginUri = _.get(config, 'customLoginUri') || '';
        this.handleAuthentication = this.handleAuthentication.bind(this);
        this.setSession = this.setSession.bind(this);
        this.logout = this.logout.bind(this);
        this.login = this.login.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.renewTokens = this.renewTokens.bind(this);
        this.localLogin = this.localLogin.bind(this);
        this.scheduleRenewal = this.scheduleRenewal.bind(this);
        this.resetSession = this.resetSession.bind(this);
        this.setAuthData = this.setAuthData.bind(this);
        this.setAuthResult = this.setAuthResult.bind(this);
        var webAuthConfig = _.omit(config, ['customLoginUri']);
        this.auth0 = new auth0_js_1.default.WebAuth(webAuthConfig);
    }
    Auth0.prototype.handleAuthentication = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth0.parseHash(function (err, authResult) {
                if (authResult && authResult.accessToken && authResult.idToken) {
                    _this.setSession(authResult)
                        .then(function (data) {
                        _this.redirectTo('/');
                        resolve(data);
                    });
                }
                else if (err) {
                    reject(err);
                }
                else {
                    resolve({
                        authenticated: false,
                    });
                }
            });
        });
    };
    Auth0.prototype.setSession = function (authResult) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
                this.authData = authResult
                    ? {
                        accessToken: String(authResult.accessToken),
                        idToken: String(authResult.idToken),
                        expiresAt: String(this.expiresAt),
                        idp_uuid: String(authResult.idTokenPayload.sub),
                    } : this.authData;
                this.localLogin(authResult);
                _.assign(AUTH, this);
                return [2, { authenticated: true }];
            });
        });
    };
    Auth0.prototype.logout = function () {
        Cookie.set('isLoggedIn', 'false');
        Cookie.remove('expiresAt');
        this.authenticated = false;
        this.expiresAt = '';
        this.accessToken = '';
        this.idToken = '';
        _.assign(AUTH, this);
        clearTimeout(this.tokenRenewalTimeout);
        this.login();
    };
    Auth0.prototype.isAuthenticated = function () {
        var expiresAt = _.toNumber(Cookie.get('expiresAt'));
        var now = new Date().getTime();
        var isAuthenticated = now < expiresAt;
        return isAuthenticated;
    };
    Auth0.prototype.renewTokens = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth0.checkSession({}, function (err, result) {
                if (!err) {
                    _this.localLogin(result);
                    resolve(result);
                }
                else {
                    _this.login();
                    reject();
                }
            });
        });
    };
    Auth0.prototype.localLogin = function (authResult) {
        this.idToken = authResult.idToken;
        this.expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        this.accessToken = authResult.accessToken;
        this.authenticated = true;
        this.authResult = authResult;
        Cookie.set('isLoggedIn', 'true');
        Cookie.set('expiresAt', this.expiresAt);
        _.assign(AUTH, this);
        this.scheduleRenewal();
    };
    Auth0.prototype.scheduleRenewal = function () {
        var _this = this;
        var delay = _.toNumber(this.expiresAt) - Date.now();
        if (delay > 0) {
            this.tokenRenewalTimeout = setTimeout(function () {
                _this.renewTokens();
            }, delay);
        }
    };
    Auth0.prototype.resetSession = function () {
        var _this = this;
        this.auth0.checkSession({}, function (err, authResult) {
            if (authResult && authResult.accessToken && authResult.idToken) {
                _this.setSession(authResult)
                    .then(function () {
                    _this.redirectTo('/');
                });
                _this.scheduleRenewal();
            }
            else if (err) {
                _this.logout();
            }
        });
    };
    Auth0.prototype.login = function () {
        if (this.customLoginUri) {
            this.redirectTo(this.customLoginUri);
        }
        else {
            this.auth0.authorize();
        }
    };
    Auth0.prototype.setAuthData = function (auth0Data) {
        this.authData = _.assign(this.authData, auth0Data);
        _.assign(AUTH, this);
    };
    Auth0.prototype.setAuthResult = function (authResult) {
        this.authResult = _.assign(this.authResult, authResult);
        _.assign(AUTH, this);
    };
    Auth0.prototype.loginAuth0 = function (username, password) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.auth0.login({
                username: username,
                password: password,
            }, function (err) {
                if (err) {
                    __1.logger.message(err, logger_const_1.LOG_TYPE.error);
                }
                resolve();
            });
        }).then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.renewTokens()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); });
    };
    Auth0.prototype.redirectTo = function (to) {
        if (window && window.location) {
            window.location.replace(to);
        }
    };
    return Auth0;
}());
var AUTH = {};
exports.authService = {
    init: function (_a) {
        var domain = _a.domain, clientID = _a.clientID, redirectUri = _a.redirectUri, audience = _a.audience, responseType = _a.responseType, scope = _a.scope, customLoginUri = _a.customLoginUri;
        if (!_.isEmpty(AUTH)) {
            throw new Error('Auth should be initialised only once');
        }
        if (!domain || !clientID || !redirectUri || !audience || !responseType || !scope) {
            throw new Error('Please, check the configuration!');
        }
        var instance = new Auth0({
            domain: domain,
            clientID: clientID,
            redirectUri: redirectUri,
            audience: audience,
            responseType: responseType,
            scope: scope,
            customLoginUri: customLoginUri,
        });
        _.assign(AUTH, instance);
    },
    instance: AUTH,
};
exports.auth0Instance = exports.authService.instance;
